<template>
    <v-form
        ref="form"
        :model="input"
        :action="endpoint"
        :method="method"
        @submitted="handleSubmitted"
    >
        <template scope="{ error, errorState }">
            <v-input-field
                label="First Name"
                description="The speaker's first name."
                v-model="input.first_name"
                :error="error('first_name')"
                placeholder="Enter First Name"
                :state="errorState('first_name')"
            />

            <v-input-field
                label="Last Name"
                description="The speaker's last name."
                v-model="input.last_name"
                :error="error('last_name')"
                placeholder="Enter Last Name"
                :state="errorState('last_name')"
            />

            <v-rich-text-field
                label="Bio"
                description="The bio for the speaker."
                v-model="input.bio"
                :error="error('bio')"
                placeholder="Enter Bio"
                :state="errorState('bio')"
            />

            <v-image-file-field
                name="image_id"
                label="Image"
                description="Any size."
                :state="errorState('image_id')"
                :error="error('image_id')"
                v-model="input.image_id"/>

            <v-input-field
                label="Website"
                description="The website URL for the speaker."
                v-model="input.website"
                :error="error('website')"
                placeholder="Enter URL"
                :state="errorState('website')"
            />

            <v-input-field
                label="Twitter Handle"
                description="Without the @."
                v-model="input.twitter_handle"
                :error="error('twitter_handle')"
                placeholder="Enter Twitter Handle"
                :state="errorState('twitter_handle')"
            />

            <v-input-field
                label="Instagram Username"
                description="Without the @."
                v-model="input.instagram_username"
                :error="error('instagram_username')"
                placeholder="Enter Instagram Username"
                :state="errorState('instagram_username')"
            />

            <v-input-field
                label="Facebook Username"
                description="Without the @."
                v-model="input.facebook_username"
                :error="error('facebook_username')"
                placeholder="Enter Facebook Username"
                :state="errorState('facebook_username')"
            />

            <v-input-field
                label="Position"
                description="The speaker's job title."
                v-model="input.position"
                :error="error('position')"
                placeholder="Enter Position"
                :state="errorState('position')"
            />

            <v-input-field
                label="Organization"
                description="The speaker's place of work."
                v-model="input.organization"
                :error="error('organization')"
                placeholder="Enter Organization"
                :state="errorState('organization')"
            />
        </template>
    </v-form>
</template>

<script>
    import axios from "axios"
    import MessagesField from "../Fields/MessagesField"

    export default {
        components: {MessagesField},
        props: ["speaker"],
        data()
        {
            return {
                input: {
                    first_name: null,
                    last_name: null,
                    bio: null,
                    website: null,
                    twitter_handle: null,
                    facebook_username: null,
                    instagram_username: null,
                    image_id: null,
                    position: null,
                    organization: null
                },
                error: ""
            }
        },
        computed: {
            exists()
            {
                return this.speaker ? true : false
            },
            endpoint()
            {
                if (this.exists) {
                    return "/speakers/" + this.speaker.id
                } else {
                    return "/speakers"
                }
            },
            method()
            {
                if (this.exists) {
                    return "PUT"
                } else {
                    return "POST"
                }
            }
        },
        created()
        {
            if (this.exists) {
                this.input = this.speaker
            }
        },
        methods: {
            handleSubmitted()
            {
                if (!this.exists) {
                    location.href = "/speakers"
                }
            }
        }
    }
</script>